import React from 'react';

import { Svg, type SvgProps } from './svg';

export function UploadIcon(props: SvgProps) {
  return (
    <Svg data-testid="upload-icon" {...props}>
      <path d="M19.35 10.04a7.49 7.49 0 0 0-14-2A6 6 0 0 0 6 20h13a5 5 0 0 0 5-5 4.98 4.98 0 0 0-4.65-4.96ZM19 18H6a4 4 0 0 1-.44-7.97l1.07-.11.5-.95a5.5 5.5 0 0 1 10.26 1.46l.3 1.5 1.53.11A2.98 2.98 0 0 1 19 18ZM8 13h2.55v3h2.9v-3H16l-4-4-4 4Z" />
    </Svg>
  );
}
